import * as React from "react";
import { Card, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import NavigationTop from "../../../components/NavigationTop";

export const PageNotFound: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="main">
            <Container className="container-main">
                <NavigationTop />

                <Card>
                    <Card.Header>{t("Page Not Found")}</Card.Header>
                    <Card.Body>
                        <p>
                            {t(
                                "Page not found. Check URL address and use top navigation bar..."
                            )}
                        </p>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};
